import api from "@/lib/api";

export const STEP_CLIP_MAX = 15;
export const STEP_CLIP_MAX_MB = 40;
const CHUNK = 5 * 1024 * 1024;

// Grab a JPEG poster frame (~0.1s in) + duration from a local video file.
export function videoPoster(file, maxDim = 1600) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const v = document.createElement("video");
    v.muted = true; v.playsInline = true; v.preload = "auto"; v.src = url;
    const fail = () => { URL.revokeObjectURL(url); reject(new Error("unreadable")); };
    v.onerror = fail;
    v.onloadedmetadata = () => { v.currentTime = Math.min(0.1, (v.duration || 1) / 2); };
    v.onseeked = () => {
      let w = v.videoWidth, h = v.videoHeight;
      if (!w || !h) return fail();
      const sc = Math.min(1, maxDim / Math.max(w, h));
      w = Math.round(w * sc); h = Math.round(h * sc);
      const c = document.createElement("canvas");
      c.width = w; c.height = h;
      c.getContext("2d").drawImage(v, 0, 0, w, h);
      const out = { poster: c.toDataURL("image/jpeg", 0.85), duration: Number.isFinite(v.duration) ? v.duration : 0 };
      URL.revokeObjectURL(url);
      resolve(out);
    };
  });
}

// Chunked upload of one step clip, then server-side trim/normalize.
// Stand-in poster when the browser can't decode the clip (server swaps in the real first frame).
export function placeholderPoster() {
  const c = document.createElement("canvas");
  c.width = 640; c.height = 360;
  const g = c.getContext("2d");
  g.fillStyle = "#16151f"; g.fillRect(0, 0, 640, 360);
  g.fillStyle = "#f0c975"; g.font = "bold 34px sans-serif"; g.textAlign = "center";
  g.fillText("Video clip", 320, 175);
  g.fillStyle = "rgba(255,255,255,.6)"; g.font = "20px sans-serif";
  g.fillText("preview after upload", 320, 215);
  return c.toDataURL("image/jpeg", 0.85);
}

export async function uploadStepClip(manualId, index, file, keepSound, onProgress, serverPoster = false, trimStart = 0) {
  const uploadId = (crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random()).replace(/[^a-z0-9-]/gi, "");
  const base = `/manuals/${manualId}/steps/${index}/clip`;
  const total = Math.ceil(file.size / CHUNK);
  for (let i = 0; i < total; i++) {
    const fd = new FormData();
    fd.append("upload_id", uploadId);
    fd.append("chunk_index", i);
    fd.append("chunk", file.slice(i * CHUNK, (i + 1) * CHUNK), "chunk");
    await api.post(`${base}/upload-chunk`, fd);
    onProgress?.((i + 1) / total);
  }
  const { data } = await api.post(`${base}/finalize`, { upload_id: uploadId, keep_sound: !!keepSound, server_poster: !!serverPoster, trim_start: trimStart || 0 });
  return data.clip;
}
